<template>
  <div style="height: 100%">
    <el-container class="main_box" id="home" v-loading="loading">
      <el-aside class="aside shadow_box noselect">
        <div class="member_info">
          <dl class="member_card" @click="RouteGo('NowManager')">
            <dt class="card_title">
              <span style="width:70%;overflow: hidden;text-overflow: ellipsis;white-space:nowrap">{{ Userinfo.secretary.organization_name }}</span>
            </dt>
            <dd class="clearfix">
              <div class="photo">
                <img :src="Userinfo.secretary.real_avatar" />
              </div>
              <div class="info">
                <p>
                  <strong>{{ Userinfo.secretary.secretary_name}}</strong>
                </p>
                <!-- <p><span class="title">{{ Userinfo.secretary.is_com }}</span></p> -->
                <p>
                  <span class="title">{{ chengType(Userinfo.secretary.is_com)  }}</span>
                </p>
              </div>
            </dd>
            <dd class="personal_profile">
              <!-- <div class="ellipse_2">{{ Userinfo.secretary.introduction }}</div> -->
              <div class="ellipse_2">{{ Userinfo.secretary.introduction }}</div>
            </dd>
          </dl>
        </div>
        <div class="box_card">
          <h2>常用功能</h2>
          <CommonMenu ref="CommonMenu" />
          <div class="manage_common" @click="ManagementChage">
            <i class="icon i_setcommons"></i><span>管理常用应用</span>
          </div>
        </div>
      </el-aside>
      <el-main class="main_info">
        <div class="main_info_content">
          <!-- start progress area -->
          <div class="proportion">
            <!-- 党委数据展示 -->
            <ul v-if="!$store.state.IsBranch">
              <li>
                <div>
                  <div class="gress_box">
                    <p>
                      {{ $store.state.IsBranch ? "组织总人数" : "组织总人数" }}
                    </p>
                    <p>{{ Numberlist.totalNum }}</p>
                  </div>
                </div>
              </li>

              <li>
                <div>
                  <div class="gress_box">
                    <p>党组织数量(直属下级)</p>
                    <p>{{ Numberlist.organizationTotalNum }}</p>
                  </div>
                </div>
              </li>

              <li>
                <div>
                  <div class="gress_box">
                    <div class="clearfix">
                      <div class="persent_part">
                        <p>党员总人数（含预备党员）</p>
                        <p>{{ Numberlist.memberNum }}</p>
                      </div>
                      <div class="persent_part">
                        <!-- <p>非党员</p>
                        <p>{{ Numberlist.totalNum-Numberlist.memberNum }}</p> -->
                      </div>
                    </div>
                  </div>
                  <p class="samll_text">党员总人数占比</p>
                  <el-progress v-if="
                      Numberlist.memberNum !== undefined &&
                      Numberlist.totalNum !== undefined
                    " :percentage="
                      contpercentage(Numberlist.memberNum, Numberlist.totalNum)
                    " :color="customColor"></el-progress>
                </div>
              </li>

              <li>
                <div>
                  <div class="gress_box">
                    <div class="clearfix">
                      <div class="persent_part">
                        <p>男党员</p>
                        <p>{{ Numberlist.nan_num }}</p>
                      </div>
                      <div class="persent_part">
                        <p>女党员</p>
                        <p>{{ Numberlist.nvxing_num }}</p>
                      </div>
                    </div>
                    <div class="clearfix">
                      <div class="persent_part">
                        <p class="samll_text">男党员占比</p>
                        <el-progress v-if="Numberlist.nan_percent !== undefined" :percentage="Number(Numberlist.nan_percent)"
                          :color="customColor" :format="format"></el-progress>
                      </div>
                      <div class="persent_part">
                        <p class="samll_text">女党员占比</p>
                        <el-progress v-if="Numberlist.nv_percent !== undefined" :percentage="Number(Numberlist.nv_percent)" :color="customColor" :format="format">
                        </el-progress>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>

            <!-- 党支部数据展示 -->
            <ul v-if="$store.state.IsBranch">
              <li>
                <div>
                  <div class="gress_box">
                    <p>组织总人数</p>
                    <p>{{ Numberlist.totalNum }}</p>
                  </div>
                </div>
              </li>
              <li>
                <div>
                  <div class="gress_box">
                    <p>党员总人数</p>
                    <p>{{ Numberlist.memberNum }}</p>
                  </div>
                </div>
              </li>

              <li>
                <div>
                  <div class="gress_box">
                    <div class="clearfix">
                      <div class="persent_part">
                        <p>男党员</p>
                        <p>{{ Numberlist.nan_num }}</p>
                      </div>
                      <div class="persent_part">
                        <p>女党员</p>
                        <p>{{ Numberlist.nvxing_num }}</p>
                      </div>
                    </div>
                    <div class="clearfix">
                      <div class="persent_part">
                        <p class="samll_text">男党员占比</p>
                        <el-progress v-if="Numberlist.nan_percent !== undefined"
                          :percentage="Number(Numberlist.nan_percent)" :color="customColor" :format="format">
                        </el-progress>
                      </div>
                      <div class="persent_part">
                        <p class="samll_text">女党员占比</p>
                        <el-progress v-if="Numberlist.nv_percent !== undefined" :percentage="Number(Numberlist.nv_percent)" :color="customColor" :format="format">
                        </el-progress>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              <li>
                <div>
                  <div class="gress_box">
                    <p class="samll_text">大专以上学历</p>
                    <p>{{ Numberlist.education_num }}</p>
                  </div>
                  <p class="samll_text">大专以上学历党员占比</p>
                  <el-progress v-if="
                      Numberlist.education_num !== undefined &&
                      Numberlist.memberNum !== undefined
                    " :percentage="
                      contpercentage(
                        Numberlist.education_num,
                        Numberlist.memberNum
                      )
                    " :color="customColor"></el-progress>
                </div>
              </li>
            </ul>
          </div>
          <!-- end progress area -->

          <!-- start content column area -->
          <el-container>
            <el-main>
              <div class="content_box shadow_box">
                <h3 class="clearfix">
                  <strong>{{
                     o_category_id==4?'组织部会议统计':(
                    $store.state.IsBranch ? "三会一课" : "党总支会议统计")
                    }}</strong>
                </h3>
                <div class="content_info">
                  <!-- <Echarts :MeetingStat="MeetingStat" v-if="$store.state.IsBranch"/> -->
                  <Columnar :MeetingStat="MeetingStat" />
                </div>
              </div>
              <div class="content_box shadow_box">
                <h3 class="clearfix">
                  <span class="more" @click="RouteGo('Schema')">更多>></span><strong>{{
                    o_category_id==4?'组织部委员分工':(
                    $store.state.IsBranch
                    ? "党支部委员分工"
                    : "党总支委员分工")
                    }}</strong>

                </h3>
                <div class="content_info">
                  <!-- <ul class="member_info_list">
                    <li v-for="(item, index) in PartyMemberList" :key="index"
                        @click="RouteGo('Schema', { id: item.id })">
                      <dl>
                        <dt class="photo">
                          <img :src="item.real_avatar"/>
                        </dt>
                        <dd>
                          <p>{{ item.real_name }}</p>
                          <p>
                            {{
                              item.type_name === "" ? "暂无" : item.type_name
                            }}
                          </p>
                        </dd>
                      </dl>
                    </li>
                  </ul> -->
                  <ul class="divide" id="divide">
                    <li v-for="(item, index) in PartyMemberList" :key="index">
                      <img :src="item.real_avatar" width="100" height="115" />
                      <p>{{item.real_name}}</p>
                      <p>{{chengType(item.type_name)}}</p>
                    </li>
                  </ul>
                </div>
              </div>
            </el-main>
            <el-aside width="270px" class="r_side">
              <div class="content_box shadow_box">
                <h3 class="clearfix"><strong>信息通知</strong></h3>
                <div class="content_info">
                  <ul class="msg_list pointer">
                    <li class="no_read" v-for="(e, i) in noticeList" :key="i" @click="readed(e)">
                      <h6 class="ellipse_1">{{ e.remark }}</h6>
                      <p>{{ e.create_time }}</p>
                      <i class="new" v-if="e.is_read === 0">新</i>
                      <i class="el-icon-arrow-right"></i>
                    </li>
                    <li style="text-align: center" v-if="noticeList.length === 0">
                      暂无消息通知
                    </li>
                  </ul>
                </div>
              </div>
            </el-aside>
          </el-container>
        </div>
      </el-main>
    </el-container>
    <MessageBox v-if="isedit" class="edit_og_info" :options="pop_options">
      <div class="Management">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px">
          <el-form-item label="选择功能">
            <el-transfer v-model="form.id" filterable filter-placeholder="请输入搜索功能名称" :data="comlist"
              :titles="['可选常用功能', '已选常用功能']" :button-texts="['删除', '添加']">
            </el-transfer>
          </el-form-item>
        </el-form>
      </div>
    </MessageBox>
  </div>
</template>
<script>
  import store from "@/store/store.js"
  import {
    longPress
  } from "@/assets/js/common/saveimg"
  import MessageBox from "@/components/MessageBox";
  import CommonMenu from "@/components/CommonMenu"
  import Echarts from "@/components/Echarts"
  import Columnar from "@/components/Echarts/Columnar"
  import {
    getNumberapi,
    getMeetingStatapi,
    getsStyleapi,
  } from "../../network/api/home"
  import {
    getInfoapi
  } from "../../network/api/login"
  import {
    parseTime
  } from "../../assets/js/utils";

  var ws;
  export default {
    components: {
      CommonMenu,
      Echarts,
      MessageBox,
      Columnar
    },
    // ...mapState({
    //     noticeList: (state) => state.websocket.dai_comeInfo,
    // }),
    data() {
      return {
        o_category_id:0,
        orgGet: {},
        form: {
          id: [], // 功能id
          title: "", // 功能名字
        },
        rules: {}, // 验证
        comlist: [], // 常用功能
        selected: [], // 已选功能数组
        noChoose: [], // 未选功能数组
        isedit: false, //
        pop_options: {
          title: "常用应用管理",
          contents: "",
          widths: 1000,
          type: 2,
          callback: {
            comfirm: () => {
              this.onSubmits()
              setTimeout(res => {
                this.$refs.CommonMenu.getManagement();
              }, 200)
            },
            cancel: () => {
              this.isedit = false
            },
            close: () => {
              this.isedit = false
            },
          },
        },
        // MessageBox传参
        options: {},
        MessageBoxHandle: false, //控制显示
        loading: true,
        mask: false, // 蒙版
        noticeList: [],
        percentage: 20,
        customColor: "#ec3333",
        Userinfo: {
          secretary: {},
        },
        Numberlist: {}, //支部人员数据
        MeetingStat: {}, //会议类型统计图数据
        PartyMemberList: {}, //党员风采
        meetingtotal: 0,
      };
    },
    watch: {
      "$store.state.HCNotice"(newInfo, oldInfo) {
        this.noticeList.unshift(newInfo);
      },
    },
    computed: {
      contpercentage(onenum, twonum) {
        return (onenum, twonum) => {
          if (twonum != 0) {
            return Math.round(Number(onenum / twonum) * 100);
          } else {
            return 0;
          }
        };
      },
      chengType(){
     
        return function (name){
          console.log(name)
          return  name.replace(/党委/g, "党总支")
        }
      }
    },
    updated() {
      longPress();
    },
    created() {
      const idOrc = parseInt(this.$getSession("ISCOM"))
      this.orgGet.identity = this.$store.state.IdentityLevel
      this.gethomedata();
      this.getMessage();
      this.GetIdentity();
    },
    methods: {
      async GetIdentity() {
        const data = await this.PublicApi("admin/organization/getId")
        // 管理人员身份认证获取
        this.$setSession("ISCOM", data.data.is_com)
        this.$store.state.Identity = data.data.is_com === 1 ? "党委" : "支部"
        this.$store.state.IdentityLevel = data.data.is_com === 1 ? "委员" : "党员"
        this.$store.state.IsBranch = data.data.is_com === 1 ? false : true
        this.o_category_id=data.data.o_category_id
        // 设置组织等级
        this.$setSession("OCATEGRORYID", data.data.o_category_id)
          //设置是否是领头羊
          this.$setSession("is_top_public", data.data.is_top_public)
      },
      // 选择功能
      async onSubmits() {
        let palyat = {
          myNav: this.form.id.toString()
        }
        const data = await this.PublicApi("/admin/setting/navUpd",
          palyat
        )
        if (data.status == 200) {
          this.isedit = false
        }
      },

      // 获取数据列表
      async getManagement() {
        const data = await this.PublicApi("/admin/setting/navList")
        this.comlist = [];

        // 全部功能
        data.data.navList.forEach(res => {
          this.comlist.push({
            key: res.id,
            label: res.title,
          })
        });

        // 已选功能
        this.selected = [];
        data.data.myNav.forEach(res => {
          this.selected.push({
            key: res.id,
            label: res.title,
          })
          this.form.id.push(res.id)
        });

      },
      // 管理常用功能
      ManagementChage() {
        this.isedit = true
        this.form.id = []
        this.getManagement();
      },
      // 信息通知处理
      readed(e) {
        //  type类型: 1:认证申请 2党员发展 3:党员之声 4:上下级文件
        switch (e.type) {
          case 1:
            //0表示未处理，1表示已通过，2表示未通过
            let newStatus
            switch (e.status) {
              case 0:
                newStatus = "党员认证（未处理）";
                this.$confirm(e.remark, newStatus, {
                  distinguishCancelAndClose: true,
                  confirmButtonText: "同意",
                  cancelButtonText: '不同意',
                  type: "info",
                }).then(() => {
                  this.PublicApi("/admin/notice/setNotice", {
                    id: e.id,
                    status: 1
                  }).then(res => {
                    this.getMessage()
                  })
                }).catch((ev) => {
                  if (ev === "cancel") {
                    this.PublicApi("/admin/notice/setNotice", {
                      id: e.id,
                      status: 2
                    }).then(res => {
                      this.getMessage()
                    })
                  }
                })

                break
              case 1:
                newStatus = "党员认证（处理结果：已同意）"
                this.$confirm(e.remark, newStatus, {
                  distinguishCancelAndClose: true,
                  confirmButtonText: "我知道了",
                  showCancelButton: false,
                  type: "info",
                }).then(() => {

                })
                break
              case 2:
                newStatus = "党员认证（处理结果：未同意）"
                this.$confirm(e.remark, newStatus, {
                  distinguishCancelAndClose: true,
                  confirmButtonText: "我知道了",
                  showCancelButton: false,
                  type: "info",
                }).then(() => {

                })
                break
              default:
                newStatus = "党员认证"
                this.$confirm(e.remark, newStatus, {
                  distinguishCancelAndClose: true,
                  confirmButtonText: "我知道了",
                  showCancelButton: false,
                  type: "info",
                }).then(() => {

                })
                return
            }

            break
          case 2:
            this.$confirm(e.remark, "消息内容", {
              confirmButtonText: "前往处理",
              cancelButtonText: '暂不处理',
              type: "info",
            }).then(() => {
              this.RouteGo(
                "GrowingReview", {
                id: e.source_id
              }
              )
            }).catch((ev) => {
              // console.log(ev)
            })
            break
          case 3:
            this.$confirm(e.remark, "党员之声", {
              confirmButtonText: "前往查看",
              cancelButtonText: '暂不查看',
              type: "info",
            }).then(() => {
              this.RouteGo("ComplaintsBox")
            }).catch((ev) => {
              return
            })
            break
          case 5:
            if (e.status == 1) {
              this.$confirm(e.remark, '修改资料', {
                distinguishCancelAndClose: true,
                confirmButtonText: "我知道了",
                showCancelButton: false,
                dangerouslyUseHTMLString: true,
                type: "info",
              }).then(() => {

              })

            }
            else {
              this.$confirm(e.remark, '修改资料', {
                distinguishCancelAndClose: true,
                confirmButtonText: "同意",
                cancelButtonText: '不同意',
                dangerouslyUseHTMLString: true,
                type: "info",
              }).then(() => {
                this.PublicApi("/admin/notice/setNotice", {
                  id: e.id,
                  status: 1
                }).then(res => {
                  this.getMessage()
                })
              }).catch((ev) => {
                if (ev === "cancel") {
                  this.PublicApi("/admin/notice/setNotice", {
                    id: e.id,
                    status: 2
                  }).then(res => {
                    this.getMessage()
                  })
                }
              })

            }
            break
          default:
            this.$alert(e.remark, "消息通知", {
              confirmButtonText: "我知道了",
              type: "info",
            }).then(() => {
              // 处理阅读状态
              if (e.is_read === 0) {
                e.is_read = 1
                this.PublicApi("/admin/notice/markRead", {
                  id: e.id,
                })
              }
              // console.log("您已经阅读过了本条通知")
            }).catch((ev) => {
              // console.log(ev)
            })
            return
        }
        // 处理阅读状态
        if (e.is_read === 0) {
          e.is_read = 1
          this.PublicApi("/admin/notice/markRead", {
            id: e.id,
          })
        }
      },

      async getMessage() {
        let data = await this.PublicApi(
          "/admin/base/getsListByLimit", {
          limit: 50,
        },
          "get"
        );
        this.noticeList = data.data;
        //  /admin/base/getsListByLimit
      },
      async gethomedata() {
        // 登录者信息
        let userinfos = await getInfoapi();
        this.Userinfo = userinfos.data;
        // console.log(this.Userinfo)
        if (this.Userinfo.secretary.introduction === "") {
          this.Userinfo.secretary.introduction = "该用户暂未填写简介";
        }
        if (this.Userinfo.secretary.real_avatar === "") {
          this.Userinfo.secretary.real_avatar = require("@/assets/images/default_photo.jpg")
        }
        // 支部成员情况
        let data01 = await getNumberapi();
        this.Numberlist = data01.data;
        // 会议类型统计
        var date = new Date();
        let data02 = await getMeetingStatapi({
          month: `${date.getFullYear()}-12`,
          nearMonth: 12,
          type: 1
        });
        this.MeetingStat = data02.data;
        this.meetingtotal = data02.data.total;
        // 党员风采
        let data03 = await getsStyleapi({
          page: 1,
          limit: 8
        });
        this.PartyMemberList = data03.data;
        for (const i in this.PartyMemberList) {
          if (
            this.PartyMemberList[i].real_avatar === "" ||
            this.PartyMemberList[i].real_avatar === null
          ) {
            this.PartyMemberList[
              i
            ].real_avatar = require("@/assets/images/default_photo.jpg");
          }
        }
        this.loading = false
      },
      format(percentage) {
        return `${Number(percentage)}%`;
      }
    },
  };
</script>
<style lang="less" scoped>
  .divide {
    min-height: 164px;

    li {
      float: left;
      width: 130px;
      margin-left: 15px;
      text-align: center;

      p {
        margin-top: 5px;
        font-size: 12px;
        text-align: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Home/index.vue